import React from 'react';
import { Input } from 'antd';
import { CustomComponentProps } from '../types';

const { TextArea } = Input;

/**
 * Custom TextArea wrapper component
 */
export interface MyTextAreaProps extends CustomComponentProps {
  rows?: number;
  maxLength?: number;
  showCount?: boolean;
  autoSize?: boolean | { minRows?: number; maxRows?: number };
  allowClear?: boolean;
}

const MyTextArea: React.FC<MyTextAreaProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  readonly,
  rows = 4,
  maxLength,
  showCount = true,
  autoSize,
  allowClear = true,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <TextArea
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled || readonly}
      rows={rows}
      maxLength={maxLength}
      showCount={showCount}
      autoSize={autoSize}
      allowClear={allowClear}
      {...rest}
    />
  );
};

export default MyTextArea;
